export default __webpack_public_path__ + "static/media/how-to.5f55925d.mp4";